import { render, staticRenderFns } from "./preset-book-detail.component.vue?vue&type=template&id=06bcb0d8"
import script from "./preset-book-detail.component.vue?vue&type=script&lang=ts"
export * from "./preset-book-detail.component.vue?vue&type=script&lang=ts"
import style0 from "./preset-book-detail.style.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports